import { SET_APP_SETTINGS, IAppSettings } from "./app-settings-types";

export const setAppSettings = (appSettings: IAppSettings) => ({
    type: SET_APP_SETTINGS,
    appSettings,
});
